<section class="homepage">
    <p class="homepage__amvara__tagline">{{ 'home.tagline' | transloco }}</p>
    <div class="homepage__logo">
        <img routerLink="about" [attr.alt]="'home.logoAlt' | transloco" src="assets/img/amvara_web_logo.svg" class="homepage__logo__img" >
    </div>
    <p class="homepage__amvara__born">{{ 'home.born' | transloco }}</p>
</section>
